"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledText = exports.HotelTariffOffer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _localization = require("@lt/localization");
var _tagTypes = require("../../HotelCardTag/utils/tagTypes");
var _MobilePopupBottom = _interopRequireDefault(require("../../MobilePopupBottom"));
var _CurrencyFormat = _interopRequireDefault(require("../../CurrencyFormat"));
var _HotelOfferButton = _interopRequireDefault(require("../../HotelOfferButton/HotelOfferButton"));
var _Hot = _interopRequireDefault(require("../../../icons-react/rebrand/Hot"));
var _HotelCardTag = _interopRequireDefault(require("../../HotelCardTag/HotelCardTag"));
var _utils = require("../../CancellationPolicy/assets/utils");
var _types = require("./types");
var _utils2 = require("./utils");
var _CancellationOff = _interopRequireDefault(require("../../../icons-react/rebrand/CancellationOff"));
var _CancellationOn = _interopRequireDefault(require("../../../icons-react/rebrand/CancellationOn"));
var _CancelledCancellation = _interopRequireDefault(require("../../../icons-react/userflow/CancelledCancellation"));
var _Like = _interopRequireDefault(require("../../../icons-react/rebrand/Like"));
var _QuestionFill = _interopRequireDefault(require("../../../icons-react/rebrand/QuestionFill"));
var _Bubble = _interopRequireDefault(require("../../Bubble"));
var _CancellationPolicyMobile = _interopRequireDefault(require("../../CancellationPolicy/CancellationPolicyMobile"));
var _pluralizeUtils = require("../../../utils/pluralizeUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var HotelTariffOffer = exports.HotelTariffOffer = function HotelTariffOffer(_ref) {
  var onOfferClicked = _ref.onOfferClicked,
    tourists = _ref.tourists,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    offer = _ref.offer,
    _ref$isMobile = _ref.isMobile,
    isMobile = _ref$isMobile === void 0 ? false : _ref$isMobile;
  var price = offer.price,
    extras = offer.extras,
    nights_count = offer.nights_count,
    availability = offer.availability,
    rates = offer.rates,
    start_date = offer.start_date;
  var oldPrice = extras === null || extras === void 0 ? void 0 : extras.previous_price;
  var _useCurrency = (0, _localization.useCurrency)(),
    code = _useCurrency.code;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isActive = _useState2[0],
    setActive = _useState2[1];
  var hotPrice = extras === null || extras === void 0 ? void 0 : extras.cheap;
  var isBestPrice = extras === null || extras === void 0 ? void 0 : extras.best_price;
  var isInstantConfirm = Boolean(extras === null || extras === void 0 ? void 0 : extras.instant_confirm);
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    showPopup = _useState4[0],
    setShowPopup = _useState4[1];
  var openPopup = function openPopup() {
    return setShowPopup(true);
  };
  var closePopup = function closePopup() {
    return setShowPopup(false);
  };
  if (!rates) return null;
  var _rates$cancellation_p = rates.cancellation_policy,
    _rates$cancellation_p2 = _rates$cancellation_p.stages,
    stages = _rates$cancellation_p2 === void 0 ? [] : _rates$cancellation_p2,
    _rates$cancellation_p3 = _rates$cancellation_p.cancelated_at,
    cancellationDateISO = _rates$cancellation_p3 === void 0 ? undefined : _rates$cancellation_p3;
  var cancellationPolicyWithStartDate = _objectSpread(_objectSpread({}, rates.cancellation_policy), {}, {
    flight_date: start_date
  });
  var intervalledStages = (0, _utils.getIntervaledStages)(stages, start_date, cancellationDateISO || new Date().toISOString());
  var currentStage = (0, _utils.getCurrentStage)(intervalledStages);
  var currentReturnType = currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type;
  var refundType = _types.RETURN_TYPE[currentReturnType].type;
  var refundText = _types.RETURN_TYPE[currentReturnType].text;
  var cancellationPolicyDescription = (0, _utils2.getCancellationPolicyDescription)(currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type, currentStage === null || currentStage === void 0 ? void 0 : currentStage.end_date);
  var getIconForReturnType = function getIconForReturnType() {
    if (cancellationDateISO) return /*#__PURE__*/_react["default"].createElement(_CancelledCancellation["default"], null);
    switch (currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type) {
      case 'full':
        return /*#__PURE__*/_react["default"].createElement(_CancellationOn["default"], null);
      case 'partial':
        return /*#__PURE__*/_react["default"].createElement(_CancellationOn["default"], null);
      case 'nothing':
        return /*#__PURE__*/_react["default"].createElement(_CancellationOff["default"], null);
      default:
        return null;
    }
  };
  var icon = getIconForReturnType();
  return /*#__PURE__*/_react["default"].createElement(StyledHotelTariffOffer, {
    className: className,
    onMouseEnter: function onMouseEnter() {
      return setActive(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setActive(false);
    },
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledTariffOfferTags, null, /*#__PURE__*/_react["default"].createElement(_HotelCardTag["default"], {
    text: refundText,
    type: refundType
  }), /*#__PURE__*/_react["default"].createElement(StyledCancellationPolicyDescription, {
    returnType: currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement("span", null, cancellationPolicyDescription), (currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type) === 'full' ? /*#__PURE__*/_react["default"].createElement(StyledFullRefundIcon, null, icon) : /*#__PURE__*/_react["default"].createElement(StyledIcon, null, icon), isMobile ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledQuestionPopup, {
    onClick: openPopup
  }, /*#__PURE__*/_react["default"].createElement(_QuestionFill["default"], null)), /*#__PURE__*/_react["default"].createElement(_MobilePopupBottom["default"], {
    options: {
      showHandlebar: true
    },
    onClick: closePopup,
    visible: showPopup
  }, /*#__PURE__*/_react["default"].createElement(_CancellationPolicyMobile["default"], {
    data: cancellationPolicyWithStartDate,
    isHotelOnly: true,
    isMobilePopupComponent: true
  }))) : /*#__PURE__*/_react["default"].createElement(StyledBubble, {
    renderExtras: function renderExtras() {
      return /*#__PURE__*/_react["default"].createElement(_CancellationPolicyMobile["default"], {
        data: cancellationPolicyWithStartDate,
        isHotelOnly: true
      });
    },
    placement: "top",
    width: "max",
    text: " "
  }, /*#__PURE__*/_react["default"].createElement(StyledQuestionIcon, {
    returnType: currentStage === null || currentStage === void 0 ? void 0 : currentStage.return_type
  }, /*#__PURE__*/_react["default"].createElement(_QuestionFill["default"], null))), isBestPrice ? /*#__PURE__*/_react["default"].createElement(StyledBestPrice, null, /*#__PURE__*/_react["default"].createElement(StyledLikeIcon, null), /*#__PURE__*/_react["default"].createElement("span", null, "\u041B\u0443\u0447\u0448\u0430\u044F \u0446\u0435\u043D\u0430")) : null), !isInstantConfirm && /*#__PURE__*/_react["default"].createElement(_HotelCardTag["default"], {
    text: _tagTypes.TYPES.notToConfirmAtOnce.text,
    type: "notToConfirmAtOnce"
  })), /*#__PURE__*/_react["default"].createElement(StyledTariffOfferInfo, null, /*#__PURE__*/_react["default"].createElement(StyledHotelOfferButton, {
    price: price,
    hotPrice: hotPrice,
    isActive: true,
    onClick: function onClick() {
      return onOfferClicked(offer);
    },
    "data-at-hotel-hotel-card": offer.link,
    subtext: nights_count + ' ' + (0, _pluralizeUtils.pluralizeNights)(nights_count) + _localization.i18n.t('search.empty.night') + _localization.i18n.t('checkout.people', {
      context: "".concat(tourists)
    })
  }), oldPrice && /*#__PURE__*/_react["default"].createElement(StyledPriceBreakdownRow, null, /*#__PURE__*/_react["default"].createElement(StyledHotIcon, null), /*#__PURE__*/_react["default"].createElement(StyledOldPrice, {
    value: oldPrice,
    currencyCode: code
  })), availability.hotel === 'few' && /*#__PURE__*/_react["default"].createElement(StyledWarningTextRoomsEnd, null, _localization.i18n.t('hotelcard.card.fewHotel'))));
};
var StyledTariffOfferTags = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledTariffOfferTags",
  componentId: "sc-1rgoeii-0"
})(["display:flex;flex-direction:column;gap:8px;"]);
var StyledHotelTariffOffer = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledHotelTariffOffer",
  componentId: "sc-1rgoeii-1"
})(["padding:8px;width:-webkit-fill-available;width:-moz-available;width:fill-available;", " background-color:var(--background);display:flex;"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? (0, _styledComponents.css)(["border-radius:var(--border-radius);margin:8px;"]) : (0, _styledComponents.css)(["min-width:400px;"]);
});
var StyledCancellationPolicyDescription = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledCancellationPolicyDescription",
  componentId: "sc-1rgoeii-2"
})(["color:var(--black);font-size:14px;font-style:normal;font-weight:400;line-height:16px;"]);
var StyledTariffOfferInfo = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledTariffOfferInfo",
  componentId: "sc-1rgoeii-3"
})(["margin-left:auto;width:150px;"]);
var StyledHotelOfferButton = (0, _styledComponents["default"])(_HotelOfferButton["default"]).withConfig({
  displayName: "HotelTariffOffer__StyledHotelOfferButton",
  componentId: "sc-1rgoeii-4"
})(["width:140px;"]);
var StyledText = exports.StyledText = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledText",
  componentId: "sc-1rgoeii-5"
})(["display:flex;align-items:center;text-align:center;width:140px;font-size:14px;font-style:normal;font-weight:400;line-height:16px;color:var(--black);"]);
var StyledPriceBreakdownRow = (0, _styledComponents["default"])(StyledText).withConfig({
  displayName: "HotelTariffOffer__StyledPriceBreakdownRow",
  componentId: "sc-1rgoeii-6"
})(["display:flex;align-items:center;gap:4px;padding:4px 8px;margin:6px auto;width:fit-content;background-color:var(--lightorange);border-radius:var(--border-radius);"]);
var StyledWarningTextRoomsEnd = _styledComponents["default"].span.withConfig({
  displayName: "HotelTariffOffer__StyledWarningTextRoomsEnd",
  componentId: "sc-1rgoeii-7"
})(["width:100%;display:flex;justify-content:center;font-size:12px;font-style:normal;font-weight:400;line-height:14px;color:var(--secondary);"]);
var StyledHotIcon = (0, _styledComponents["default"])(_Hot["default"]).withConfig({
  displayName: "HotelTariffOffer__StyledHotIcon",
  componentId: "sc-1rgoeii-8"
})(["height:13px;path{fill:var(--secondary);}"]);
var StyledOldPrice = (0, _styledComponents["default"])(_CurrencyFormat["default"]).withConfig({
  displayName: "HotelTariffOffer__StyledOldPrice",
  componentId: "sc-1rgoeii-9"
})(["font-size:12px;font-style:normal;font-weight:400;line-height:14px;text-decoration:line-through;"]);
var StyledIcon = _styledComponents["default"].span.withConfig({
  displayName: "HotelTariffOffer__StyledIcon",
  componentId: "sc-1rgoeii-10"
})(["height:12px;svg{width:12px;height:12px;transform:translate(6px,2px) scale(1.33);}"]);
var StyledFullRefundIcon = _styledComponents["default"].span.withConfig({
  displayName: "HotelTariffOffer__StyledFullRefundIcon",
  componentId: "sc-1rgoeii-11"
})(["height:12px;svg{height:16px;transform:translate(6px,3px) scale(0.9);}"]);
var StyledQuestionIcon = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledQuestionIcon",
  componentId: "sc-1rgoeii-12"
})(["svg{path{fill:var(--grey2);}}transform:", ";width:14px;height:14px;"], function (_ref3) {
  var returnType = _ref3.returnType;
  return returnType === 'full' ? 'translate(10px, 1px)' : 'translate(10px, 3px)';
});
var StyledBubble = (0, _styledComponents["default"])(_Bubble["default"]).withConfig({
  displayName: "HotelTariffOffer__StyledBubble",
  componentId: "sc-1rgoeii-13"
})(["display:inline-flex;"]);
var StyledBestPrice = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledBestPrice",
  componentId: "sc-1rgoeii-14"
})(["display:flex;align-items:center;margin-top:8px;color:var(--black);font-size:14px;font-style:normal;font-weight:400;line-height:16px;"]);
var StyledLikeIcon = (0, _styledComponents["default"])(_Like["default"]).withConfig({
  displayName: "HotelTariffOffer__StyledLikeIcon",
  componentId: "sc-1rgoeii-15"
})(["height:16px;margin-right:4px;"]);
var StyledQuestionPopup = _styledComponents["default"].div.withConfig({
  displayName: "HotelTariffOffer__StyledQuestionPopup",
  componentId: "sc-1rgoeii-16"
})(["display:inline-block;width:14px;height:14px;margin-left:10px;position:relative;top:3px;svg{path{fill:var(--grey2);}}"]);